import React from 'react'

type Step = {
  name?: string | null
  text?: string | null
}

type Props = {
  name?: string | null
  description?: string | null
  steps?: Step[] | null
  className?: string
}

/**
 * Passos numerados para leitores e para espelhar `HowToStep` no JSON-LD.
 */
export function HowToBlock({ name, description, steps, className }: Props) {
  const title = typeof name === 'string' ? name.trim() : ''
  const rows =
    Array.isArray(steps)
      ? steps
          .map((s) => ({
            n: typeof s?.name === 'string' ? s.name.trim() : '',
            t: typeof s?.text === 'string' ? s.text.trim() : '',
          }))
          .filter((s) => s.n && s.t)
      : []

  if (!title || !rows.length) return null

  const desc = typeof description === 'string' ? description.trim() : ''

  return (
    <section
      className={[
        'howto-block col-start-2 my-8 rounded-lg border border-border/80 bg-muted/20 px-4 py-5 md:px-6 md:py-6',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      data-block-type="howTo"
      aria-label={title}
    >
      <h2 className="text-foreground m-0 text-xl font-semibold tracking-tight md:text-2xl">{title}</h2>
      {desc ? (
        <p className="text-muted-foreground mt-2 mb-4 text-sm leading-relaxed md:text-[0.9375rem]">{desc}</p>
      ) : null}
      <ol className="text-foreground m-0 list-decimal space-y-4 pl-5 text-sm md:text-[0.9375rem]">
        {rows.map((s, i) => (
          <li key={`${i}-${s.n.slice(0, 20)}`} className="pl-1 marker:font-semibold">
            <span className="font-semibold">{s.n}</span>
            <div className="text-muted-foreground mt-1 whitespace-pre-wrap leading-relaxed">{s.t}</div>
          </li>
        ))}
      </ol>
    </section>
  )
}
